export default {
  common: {
    allMenuList: '/merchant/app/v2/common/menuList', // 收银
    dataMenuList: '/merchant/app/v2/common/dataMenuList', // 数据
    mainMenuList: '/merchant/app/v2/common/mainMenuList', // 主菜单
    getStaffPermCode: '/merchant/app/menu/getStaffPermCode', // 获取数据权限
    verify: 'merchant/app/verifyCode/verify', // 验证码验证
    /*
        全部移动端菜单加载
        ("1", "收银台");
        ("2", "门店管理");
        ("3", "个人数据");
        ("4", "门店数据");
    */
  },
  shop: {
    list: '/merchant/app/shop/list',
    get: '/merchant/app/shop/get', //详情
    save: '/merchant/app/shop/save', //保存
    switchShop: '/merchant/app/shop/switchShop',
    getExceedInfo: '/merchant/app/shop/getExceedInfo', //门店服务到期
    getSmsNotEnoughInfo: '/merchant/app/shop/getSmsNotEnoughInfo', //短信次数耗尽
    getConfig: '/merchant/app/shop/getConfig', // 获取实时门店配置

  },
  serveCategory: {
    //服务分类
    list: '/merchant/app/serveCategory/list',
  },
  serve: {
    //服务
    list: '/merchant/app/serve/listByTime',
    listForRepair: '/merchant/app/serve/listForRepair',
  },
  productCategory: {
    //产品分类
    list: '/merchant/app/productCategory/list',
  },
  product: {
    //产品
    list: '/merchant/app/product/listByTime',
  },
  member: {
    //会员搜索
    lists: '/merchant/app/member/list', //会员-列表
    count: '/merchant/app/member/count', //会员-列表 - 总数
    get: '/merchant/app/member/get', //会员-详情
    save: '/merchant/app/member/save', //新增会员-手机号方式
    saveByIdCard: '/merchant/app/member/saveByIdCard', //新增会员-身份证方式
    ///merchant/app/member/saveByIdCard
    search: '/merchant/app/v2/member/search', //会员-搜索
    getSummary: '/merchant/app/member/getSummary', //会员-数据汇总
    list: '/merchant/app/memberCard/list', // 会员套餐卡项
    listConsumeById: '/merchant/app/memberCard/listConsumeById', // 会员套餐卡项 卡相消费明细
    listCardRight: '/merchant/app/memberCard/listCardRight', //组合卡套餐明细
    couponSendRecordList: '/merchant/app/couponSendRecord/list', //会员卡券列表
    couponSendRecordCount: '/merchant/app/couponSendRecord/count', //会员卡券列表
    couponSendRecordDetail: '/merchant/app/couponSendRecord/get', //会员卡券详情
    changeMemberPwd: '/merchant/app/member/updateMemberPwd', //会员-修改密码（接口加密）
    updateMemberInfo: '/merchant/app/member/updateMemberInfo', //会员 - 修改基本信息
    listNotTradeRange: '/merchant/app/member/listNotTradeRange', // 会员-最近交易范围
    bindMobile: '/merchant/app/member/bindMobile', // 会员-绑定手机号
    bindIdCard: '/merchant/app/member/bindIdCard', // 会员-绑定身份证
    memberLossInfo: '/merchant/app/memberLossApply/getByMemberId', // 会员 - 申请挂失 - 详情
    memberLossSave: '/merchant/app/memberLossApply/save', // 会员 - 申请挂失 - 新增
    memberLossCancel: '/merchant/app/memberLossApply/cancel', // 会员 - 申请挂失 - 撤销
    updateTradeSecret: '/merchant/app/member/updateTradeSecret', // 会员 - 免密
    saveMobile: '/merchant/app/memberMobileChange/save', // 会员修改手机号
    memberList: '/merchant/app/memberMobileChange/list', // 变更记录
  },
  memberAccount: {
    get: '/merchant/app/memberAccount/get', //会员-详情
  },
  orderInfo: {
    //收银开单
    createWares: '/merchant/app/orderInfo/createWares', //收银开单
    createCard: '/merchant/app/orderInfo/createCard', //收银开卡
    cardReduce: '/merchant/app/orderInfo/cardReduce', //收银划卡
    get: '/merchant/app/orderInfo/get', //订单详情
    // get: "/merchant/app/orderInfo/v2/getAchievement", //获取业绩明细列表
    listByTime: '/merchant/app/orderInfo/listByTime', //订单详情
    count: '/merchant/app/orderInfo/count', //订单列表 - 总数
    pay: '/merchant/app/orderInfo/pay', //收银支付
    createRecharge: '/merchant/app/orderInfo/createRecharge', //收银充值
    useConfirm: '/merchant/app/orderInfo/useConfirm', //预约核销订单
    cancel: '/merchant/app/orderInfo/cancel', //取消订单
    payForRepair: '/merchant/app/orderInfo/payForRepair', //修护档案
    updateDeduct: '/merchant/app/orderInfo/updateDeduct',
    getAchievement: '/merchant/app/orderInfo/getAchievement', // 已完成订单获取提成信息
    listItemWithStaffDeduct: '/merchant/app/v2/orderInfo/listItemWithStaffDeduct', // 申请退款提成详情
    //listItemWithStaffDeduct: '/merchant/app/orderInfo/listItemWithStaffDeduct', // 申请退款提成详情
    getBSCPayStatus: '/merchant/app/v2/orderInfo/getBSCPayStatus', // 获取通联支付状态
    getForPrint: "/merchant/app/orderInfo/getForPrint", // 获取打印小票信息
  },
  order: {
    // 新版改版接口    泡脚
    getToken: '/merchant/app/repeatToken/get', // 泡脚 确定开单  生成防止重复提交token
    createForServeProduct:
      '/merchant/app/v2/orderInfo/createForServeProduct', // 产品泡脚 - 创建订单
    discountCalculate: '/merchant/app/v2/orderInfo/discountCalculate', // 订单折扣计算
    o2oDiscountCalculate: '/merchant/app/v2/orderThirdConfirm/discountCalculate', // o2o订单折扣计算
    createCard: '/merchant/app/v2/orderInfo/createCard', // 订单创建 -卡项
    pay: '/merchant/app/v2/orderInfo/pay', // 新版订单支付
    cardReduce: '/merchant/app/v2/orderInfo/cardReduce', // 新版 - 套餐划卡 - 支付
    recharge: '/merchant/app/v2/orderInfo/rechargePay', // 新版 - 充值 - 支付
    groupCardReduce: '/merchant/app/v2/orderInfo/groupCardReduce', //  套餐划卡 - 组合划卡
    useConfirm: '/merchant/app/v2/orderThirdConfirm/useConfirm', // 验劵核销 - 支付  
    thirdConfirmMenu: '/merchant/app/v2/common/thirdConfirmMenu', // 验劵核销 - 列表  
    list: '/merchant/app/orderThirdConfirm/list', // 验劵核销 - 记录  
    get: '/merchant/app/orderThirdConfirm/get', // 验劵核销 - 详情 
    count: '/merchant/app/orderThirdConfirm/count', // 验劵核销 - 总数
    finishBySelf: '/merchant/app/orderThirdConfirm/finishBySelf', // 手动确认核销
    listRechargeItem: "/merchant/app/v2/common/listRechargeItem",  // 充值金额列表

  },
  orderInvalid: {
    //订单作废
    apply: '/merchant/app/orderInvalid/apply', //作废申请
    audit: '/merchant/app/orderInvalid/audit', //作废审核
    list: '/merchant/app/orderInvalid/list', //作废列表
    count: '/merchant/app/orderInvalid/count', //作废总数
    get: '/merchant/app/orderInvalid/get', //作废详情
  },
  paywaySet: {
    //支付方式列表
    oldList: '/merchant/app/paywaySet/list',
    oldV2list: '/merchant/app/v2/payWaySet/list',
    list: '/merchant/app/v3/payWaySet/list',
  },
  card: {
    //卡项-列表-按分类显示
    listByCateTree: '/merchant/app/card/listByCateTree',
    listNumberCard: '/merchant/app/memberCard/listNumberCard',
    checkDiscountCard: '/merchant/app/memberCard/checkDiscountCard', // 判断是否有折扣卡
    get: '/merchant/app/memberCard/get', // 卡项详情
    setInValid: '/merchant/app/memberCard/setInValid', // 作废折扣卡备注
    listCardRight: '/merchant/app/card/listCardRight', // 组合套餐权益
  },
  memberCard: {
    // 套餐划卡
    listByCateTree: '/merchant/app/memberCard/listByCateTree', // 列表
  },
  reserveInfo: {
    page: '/merchant/app/reserveInfo/page',
    get: '/merchant/app/reserveInfo/get',
  },
  repairDocument: {
    // 新建修护档案
    listRepairItem: '/merchant/app/v2/repairDocument/listRepairItem', // 部位列表
    payRepairBatch: '/merchant/app/v2/orderInfo/payRepairBatch', // 合并支付 - 修护开卡
    payRepairSingle: '/merchant/app/v2/orderInfo/payRepairSingle', // 单个支付 - 修护开卡
    save: '/merchant/app/v2/repairDocument/save',
    saveBatch: '/merchant/app/v2/repairDocument/saveBatch', // 创建修护开卡订单
    search: '/merchant/app/repairDocument/search',
    get: '/merchant/app/repairDocument/get', // 详情
    invalid: '/merchant/app/repairDocument/invalid', // 作废
    getNewestSymptom: '/merchant/app/v2/repairDocument/getNewestSymptom',
    bindMember: '/merchant/app/repairDocument/bindMember',
    // pageForRefund: '/merchant/app/repairDocument/v2/pageForRefund',
    getWithInput: '/merchant/app/repairDocument/v2/getWithInput', //修护录入
    repairCategoryListByMember:
      '/merchant/app/v2/repairDocument/listMemberCategoryGroup', //修护-按分类列表
    list: '/merchant/app/v2/repairDocument/list', // 修护开卡 - 列表
    count: '/merchant/app/v2/repairDocument/count', //  修护开卡 - 列表 - 总数
    preparePay: '/merchant/app/v2/repairDocument/preparePay', // 修护 - 批量 - 详情
    payBatchForRepair: '/merchant/app/v2/orderInfo/payBatchForRepair', // 修护 - 批量 - 支付
    checkBuildRight: '/merchant/app/v2/repairDocument/checkBuildRight', // 修护 - 是否可以开档案
    updateRemark: '/merchant/app/v2/repairDocument/updateRemark', // 修护 - 修改备注
    checkMemberAccountAmount: '/merchant/app/v2/orderInfo/checkMemberAccountAmount', //检查订单金额

    listRepairTypeItem: 'merchant/app/v2/repairDocument/listRepairTypeItem', // 修护 - 获取项目列表
    listRepairCardItem: 'merchant/app/v2/repairDocument/listRepairCardItem', // 修护 - 获取护理卡项列表 
  },
  repairRecord: {
    listForAudit: '/merchant/app/repairRecord/listForAudit', // - 列表
    count: '/merchant/app/repairRecord/count', // 列表 - 总数
    get: '/merchant/app/repairRecord/get',
    // audit: "/merchant/app/repairRecord/audit",
    update: "/merchant/app/v2/repairRecord/update", // 修护记录修改
    audit: '/merchant/app/repairRecord/audit',
    save: '/merchant/app/repairRecord/save/v2', // 旧版
    saveV2: '/merchant/app/v2/repairRecord/save', // 新版
  },
  companyRefund: {
    get: '/merchant/app/companyRefund/get', //-退款记录-详情
    list: '/merchant/app/companyRefund/list', //-退款记录-列表
    count: '/merchant/app/companyRefund/count', //-退款记录-列表-总数
    listRefundItemByOrderId: '/merchant/app/v2/companyRefund/listRefundItemByOrderId', // 退款记录-退款明细
    listRefundItemByRepairId: '/merchant/app/companyRefund/listRefundItemByRepairId', // 退款记录-退款明细
    listRefundItem: '/merchant/app/companyRefund/listRefundItem', // 退款物品清单-列表 根据退款id
    applyOrder: '/merchant/app/v2/companyRefund/applyOrder', //-订单退款
    applyRepair: '/merchant/app/v2/companyRefund/applyRepair', //-修护退款
    calculateRefundAmount: '/merchant/app/companyRefund/calculateRefundAmount', //计算退款金额
    // save: "/merchant/app/companyRefund/v2/save", //-列表
    // type  枚举值 ：member  会员 ； withdraw 提现  ；refundRepair 修护退款；refundOrder：订单退款；recharge 充值页面；
    getTips: '/merchant/app/common/getTips',
    audit: '/merchant/app/companyRefund/audit', //门店退款-审核
    withdraw: '/merchant/app/companyRefund/withdraw', //会员销卡
    getRepairDeductRatio:
      '/merchant/app/v2/companyRefund/getRepairDeductInfo', //会员销卡修护档案-计算提成比例-退款时用到
  },
  memberFundFlow: {
    list: '/merchant/app/multiData/memberFundFlow/listByShopId', //会员卡-交易列表
    count: "/merchant/app/multiData/memberFundFlow/countByShopId", // 列表-汇总
    get: '/merchant/app/report/memberCard/get', //会员卡-交易详情
    summary: '/merchant/app/report/memberFundFlow/summaryByShopId', // 会员卡-交易汇总
    pageByMember: '/merchant/app/memberFundFlow/pageByMember', //交易明细
    listByMember: '/merchant/app/multiData/memberFundFlow/list', //交易明细
    listCount: '/merchant/app/multiData/memberFundFlow/count', //交易明细
  },
  packageManagement: {
    list: '/merchant/app/memberCardShop/list', // 套餐经营 - 分页
    count: '/merchant/app/memberCardShop/count', // 套餐经营 - 总数
    sumData: '/merchant/app/memberCardShop/sumData', // 套餐经营汇总
    get: '/merchant/app/memberCardShop/get', //
  },
  cardOld: {
    list: '/merchant/app/cardOld/list', //纸质套餐-列表
    page: '/merchant/app/cardOldBook/page', //套餐顾客管理 - 列表
    get: '/merchant/app/cardOldBook/get', //纸质套餐列表-门店
    save: '/merchant/app/cardOldBook/save', //纸质套餐列表-门店顾客套餐
    pageConsume: '/merchant/app/cardOld/pageConsume', //纸质套餐列表-门店顾客套餐
    cardReduce: '/merchant/app/cardOld/cardReduce',
    cardTotal: '/merchant/app/cardOldBook/summary', // 汇总

    gets: '/merchant/app/cardOld/get', // 套餐名称管理 - 汇总
    saves: '/merchant/app/cardOld/save', //  套餐名称管理 新增/编辑
    lists: '/merchant/app/cardOld/listForShop', //  套餐名称管理 - 分页
    counts: '/merchant/app/cardOld/count', //  套餐名称管理 - 总数
  },
  cardOldBook: {
    page: '/merchant/app/cardOldBook/page', // 纸质划卡
    list: '/merchant/app/cardOldBook/list', // 套餐顾客管理-列表
    count: '/merchant/app/cardOldBook/count', //  套餐顾客管理 - 总数
  },
  companyStaff: {
    list: '/merchant/app/companyStaff/list',
    listAll: '/merchant/app/companyStaff/listAll', // 店员-列表（全部 店员列表用到）
    listAuth: '/merchant/app/companyStaff/listAuth',
    listByStaffStatus: '/merchant/app/companyStaff/listByStaffStatus', // 店员列表，分类
    listAuthForData: '/merchant/app/companyStaff/listAuthForData', // 获取店员列表
    currentStaff: '/merchant/app/companyStaff/currentStaff', //门店名称
    getDisableReason: '/merchant/app/companyStaff/getDisableReason', // 禁用原因
    listAllStaffFromWorkShop: '/merchant/app/companyStaff/listAllStaffFromWorkShop', // 店员列表 请假专用
    bankList: "merchant/app/bankInfo/list", // 银行列表
    joinOtherTenantCountByMobile: 'merchant/app/v2/companyStaff/joinOtherTenantCountByMobile', // 获取店员是否在其他公司入职
  },
  attendance: {
    // 考勤统计
    list: "/merchant/app/report/attendance/listByShop", // 列表
    listDay: '/merchant/app/multiData/attendance/list', // 列表详情   
    count: '/merchant/app/multiData/attendance/count', // 列表详情   
    listItem: "/merchant/app/multiData/attendance/listItem", // 获取打卡明细
    get: "/merchant/app/report/attendance/get", // 考勤详情
    listByStaffIdAndMonth: "/merchant/app/multiData/attendance/listByStaffIdAndMonth", // 考勤详情
    getAbnormalByStaffId: "/merchant/app/multiData/attendance/getAbnormalByStaffId", // 打卡异常列表
    listAttendanceSubsidyDetail: "/merchant/app/report/attendance/listAttendanceSubsidyDetail", // 列表
    getShopStatistics: 'merchant/app/multiData/attendance/getShopStatistics', // 汇总排行  门店考勤情况
    getDescription: 'merchant/app/attendanceApply/getDescription', // 获取异常描述
  },
  subsidySet: {
    getCashierSubsidyAmount: '/merchant/app/report/subsidySet/getCashierSubsidyAmount',
    getBySubsidyType: "/merchant/app/subsidyType/getBySubsidyType", // 列表
  },
  orderAchievement: {
    groupByStaff: '/merchant/app/report/orderAchievement/groupByStaff', //店员业绩排行
    list: '/merchant/app/multiData/orderAchievement/list', // 业绩明细
    count: '/merchant/app/multiData/orderAchievement/count', // 业绩明细 - 总数
    listByRefundId: '/merchant/app/orderAchievement/listByRefundId', // 提成明细
    sumByShop: '/merchant/app/report/orderAchievement/sumByShop', // 门店业绩
    sum: "/merchant/app/report/orderAchievement/sum", //  门店业绩 - 汇总 - 远元
  },
  companyStaffTransfer: {
    listForShop: '/merchant/app/companyStaffTransfer/listForShop', // 调店审核
    count: '/merchant/app/companyStaffTransfer/count', // 调店审核 - 总数
    audit: '/merchant/app/companyStaffTransfer/audit', // 店员调动审核
    apply: '/merchant/app/companyStaffTransfer/apply', // 店员调动申请调动
    get: '/merchant/app/companyStaffTransfer/get', // 店员调动详情
    check: '/merchant/app/companyStaffTransfer/check', // 检查是否是四个月内的新店员
  },

  paperRepairDocument: {
    //纸质修护卡
    list: '/merchant/app/paperRepairDocument/list', //列表
    count: '/merchant/app/paperRepairDocument/count', //列表 - 汇总
    get: '/merchant/app/paperRepairDocument/get', //详情
    save: '/merchant/app/paperRepairDocument/save', //保存
  },
  ///merchant/app/report/shopDataDetail
  report: {
    //门店数据 and 套餐卡-交易汇总
    shopDataDetail: '/merchant/app/report/shopDataDetail',
    summary: '/merchant/app/report/summary', // 今日数据
    list: '/merchant/app/report/numberCard/list', // 套餐卡-交易列表
    count: '/merchant/app/report/numberCard/count', // 列表-总数
    cardTradeDataSum: '/merchant/app/report/cardTradeDataSum', //套餐卡-交易汇总
    downExcelShopSalaryDetail: '/merchant/app/report/downExcelShopSalaryDetail', //移动端工资下载excel功能
    shopDataDetail: '/merchant/app/report/sumDataDetailForShop',
    sum: '/merchant/app/report/numberCard/summary', //套餐卡-交易汇总
    collectList: "/merchant/app/report/invoice/collectList",  //  门店数据 - 费用汇总 
    item: "/merchant/app/report/item/collectList",  //  门店数据 - 费用汇总 
    payway: "/merchant/app/report/payway/collectList",  //  门店数据 - 费用汇总 
    repairDocumentSummary: "/merchant/app/report/repairDocument/sumByShop",  //  档案数据
    dailyBusinessReport: "/merchant/app/report/DailyBusiness/sumByShop",  //  营业日报
    productDepositList: "/merchant/app/depositInfo/list", // 产品寄存
    productDepositCount: "/merchant/app/depositInfo/count", // 产品寄存
    productDepositDetail: "/merchant/app/depositInfo/get", // 寄存详情
    productDepositTakeInfoList: "/merchant/app/depositTakeInfo/list", // 领取明细
    depositInfoSave: "/merchant/app/depositInfo/save", // 寄存添加
    availItemList: "/merchant/app/depositItem/listAvailableItem", //可用寄存明细列表
    availableInfo: "/merchant/app/depositInfo/getAvailableInfo", //订单可用寄存信息
    getDrawStyle: "/merchant/app/depositTakeInfo/getDrawStyle", //获取领取类型
    depositTakeInfoSave: "/merchant/app/depositTakeInfo/save", //领取
  },
  staffJournal: {
    list: '/merchant/app/staffJournal/list', // 日志 - 列表
    getDetail: '/merchant/app/staffJournal/get', // 日志 - 详情
    count: '/merchant/app/staffJournal/count', // 日志 - 数据
  },
  staffBorrowInfo: {
    list: "/merchant/app/staffBorrowInfo/list", //借领列表
    detail: "/merchant/app/staffBorrowInfo/get", //借领详情
    save: "/merchant/app/staffBorrowInfo/save", //借领新增
    borrowBackSave: "/merchant/app/staffBorrowBack/save", //借领归还
    borrowBackList: "/merchant/app/staffBorrowBack/list", //借领归还列表
    count: '/merchant/app/staffBorrowInfo/count', // 借领 - 数据
  },
  shopRechargeApply: {
    //  充值额度申请
    page: '/merchant/app/shopRechargeApply/page', //额度申请-列表
    list: '/merchant/app/shopRechargeApply/list', //额度申请-列表 - 改版
    count: '/merchant/app/shopRechargeApply/count', //额度申请-列表 - 总数
    getSet: '/merchant/app/shopRechargeApply/getSet', //额度-当月使用详情
    save: '/merchant/app/shopRechargeApply/save', //额度申请-新增
  },
  invoice: {
    //发票
    list: '/merchant/app/invoice/list', //列表
    count: '/merchant/app/invoice/count', //列表总数
    get: '/merchant/app/invoice/get', //详情
    save: '/merchant/app/invoice/save', //新增
    cancel: '/merchant/app/invoice/cancel', // 撤销
  },
  invoiceCategory: {
    //发票
    list: '/merchant/app/invoiceCategory/list', //列表
  },
  companyShopStaff: {
    //店员管理
    easyAdd: '/merchant/app/v2/companyStaff/easyAdd', // 非远元会员添加店员
    easyUpdate: '/merchant/app/v2/companyStaff/easyUpdate', // 非远元会员修改店员
    listByAccountStatus: '/merchant/app/v2/companyStaff/listByAccountStatus', // 店员管理接口 在职和禁用  使用
    listAll: '/merchant/app/companyStaff/list', //店员列表
    save: '/merchant/app/v2/companyStaff/save', //保存
    update: '/merchant/app/companyStaff/update', //编辑 —— 保存
    updateStatus: '/merchant/app/companyStaff/updateStatus', // 店员禁用/启用状态切换
    listOnWork: '/merchant/app/companyStaff/listOnWork', //店员列表 —— 门店收银
    get: '/merchant/app/companyStaff/get',
    search: '/merchant/app/companyStaff/search', // 店员列表 - 搜索
    apply: '/merchant/app/companyStaffTransfer/apply', // 店员列表 - 调任
    getBankCardNo: '/merchant/app/v2/companyStaff/getBankCardNo', // 根据店员编号或者姓名查询银行卡号
    getByStaffNoOrMobile: "/merchant/app/v2/companyStaff/getByStaffNoOrMobile",  // 根据手机号/工号获取店员
    passApply: "/merchant/app/companyStaffUpdate/apply",  // 店员通过申请修改信息 - 远元
    easyApply: "/merchant/app/companyStaffUpdate/easyApply",  // 店员通过申请修改信息 - 第三方
    getShowMessageInfo: 'merchant/app/v2/companyStaff/getShowMessageInfo', // 检查是否是三个月内再次入职区域
  },
  companyStaffUpdate: {
    list: "/merchant/app/companyStaffUpdate/list", // 店员信息修改记录
    count: "/merchant/app/companyStaffUpdate/count",
    get: "/merchant/app/companyStaffUpdate/get", // 店员信息修改记录
    audit: "/merchant/app/companyStaffUpdate/audit", // 审核
  },
  companyPosition: {
    //职位
    page: '/merchant/app/companyPosition/list', //列表
  },
  companyLeave: {
    // 请假列表
    listCategory: '/merchant/app/companyLeave/listCategory', // 分类列表
    list: '/merchant/app/companyLeave/list', // 列表
    count: '/merchant/app/companyLeave/count', // 列表 - 总数
    apply: '/merchant/app/companyLeave/apply', // 申请
    get: '/merchant/app/companyLeave/get', // 详情
    cancel: '/merchant/app/companyLeave/cancel', // 撤销
    audit: '/merchant/app/companyLeave/audit', // 审核
	getLeaveDay: '/merchant/app/companyLeave/getLeaveDayNew', // 获取店员请假天数
  },
  companyQuit: {
    // 请假列表
    listCategory: '/merchant/app/companyQuit/listCategory', // 分类列表
    list: '/merchant/app/companyQuit/list', // 列表
    count: '/merchant/app/companyQuit/count', // 列表
    apply: '/merchant/app/companyQuit/apply', // 申请
    getByStaffId: '/merchant/app/companyQuit/getByStaffId', // 详情
    get: '/merchant/app/companyQuit/get', // 详情
    cancel: '/merchant/app/companyQuit/cancel', // 撤销
    audit: '/merchant/app/companyQuit/audit', // 审核
    getAllQuitType: 'merchant/app/companyQuit/getAllQuitType', // 离职详情
    listByIdCardNo: 'merchant/app/companyQuit/listByIdCardNo', // 通过身份证查询是否有离职记录
  },
  deduct: {
    //更改接口地址 从deduct 改为 shopDeduct
    listForShop: '/merchant/app/shopDeduct/listForShop', // 提成 - 分页
    count: '/merchant/app/shopDeduct/count', // 提成 - 总数
    updateRechargeRule: '/merchant/app/shopDeduct/updateRechargeRule',
    update: '/merchant/app/shopDeduct/update',
    deleteRechargeRule: '/merchant/app/shopDeduct/deleteRechargeRule',
    listRechargeRule: "/merchant/app/shopDeduct/listRechargeRule",
  },
  giftOrderInfo: {
    list: '/merchant/app/giftOrderInfo/list', // 列表
    count: '/merchant/app/giftOrderInfo/count', // 列表 - 总数 
    save: '/merchant/app/giftOrderInfo/save', // 新增
    get: '/merchant/app/giftOrderInfo/get', // 详情
    cancel: '/merchant/app/giftOrderInfo/cancel', // 取消
    listByTime: '/merchant/app/gift/listByTime', // 赠品 - 商品 - 列表
    listCategory: '/merchant/app/gift/listCategory', // 赠品 - 商品 - 分类列表
  },
  reportElectronMember: {
    summary: '/merchant/app/report/electronMember/summary',
  },
  saleTargetShop: {
    save: '/merchant/app/saleTargetShop/save', // 门店销售目标-添加
    get: '/merchant/app/saleTargetShop/get', // 门店销售目标-详情
    page: '/merchant/app/report/saleTarget/shop/completeness/get', // 门店销售目标-添加
    audit: '/merchant/app/saleTargetShop/getAudit/list', // 门店审核列表
  },
  saleTargetStaff: {
    save: '/merchant/app/saleTargetStaff/save', // 店员销售目标-添加
    page: '/merchant/app/report/saleTarget/staff/completeness/get', // 门店销售目标-添加
    get: '/merchant/app/saleTargetStaff/get', // 店员销售目标-详情
    // save: "app/saleTargetShop/save",  // 门店销售目标-添加
  },
  integralItem: {
    // 积分商品
    categroyList: '/merchant/app/integralItemCategroy/list', // 分类-列表
    list: '/merchant/app/integralItem/list', // 商品-列表
    create: '/merchant/app/integralOrderInfo/create', // 商品 - 支付
    page: '/merchant/app/integralOrderInfo/page', // 记录 - 分页
    lists: '/merchant/app/integralOrderInfo/listForShop', // 记录 - 分页
    count: '/merchant/app/integralOrderInfo/count', // 记录 - 分页
    get: '/merchant/app/integralOrderInfo/get', // 记录 - 详情
    integralList: '/merchant/app/integralFundFlow/list', // 积分账户 - 列表
    integralCount: '/merchant/app/integralFundFlow/count', // 积分账户 - 列表 - 总数
    integralGet: '/merchant/app/integralFundFlow/get', // 账户 - 详情
  },
  integralAchievement: {
    // 积分业绩
    sumByShop: '/merchant/app/report/integralAch/sumByShop', // 汇总
    list: '/merchant/app/report/integralAch/listByShop', // 记录 - 分页
    count: '/merchant/app/report/integralAch/count', // 记录 - 分页 - 总数
  },
  icCard: {
    // ic卡 转会员
    smsSends: '/merchant/app/verifyCode/sendTurn', // 发送验证码
    list: '/merchant/app/icCard/list', // 分页
    count: '/merchant/app/icCard/count', // 列表总数
    get: '/merchant/app/icCard/get', // 详情
    turnCard: '/merchant/app/icCard/turnCard', // 转入接口
  },
  icCardRecord: {
    // ic转卡记录
    list: '/merchant/app/icCardRecord/list', // 分页
    count: '/merchant/app/icCardRecord/count', // 列表总数
    get: '/merchant/app/icCardRecord/get', // 详情
  },

  storeYuanjianBill: {
    // 远舰
    doTransfer: '/merchant/app/storeYuanjianBill/doTransfer', // 远舰转账 加密
  },
  fundTransferSum: {
    // 现金上缴
    get: '/merchant/app/fundTransferSum/get', // 现金上缴 总
    fundTransferPayWayList: '/merchant/app/v2/payWaySet/fundTransferPayWayList', // 现金上缴 支付方式
    createFundOrder: '/merchant/app/fundTransferOrder/createFundOrder', // 现金上缴 订单创建(加密)
    fundTransferOrderGet: '/merchant/app/fundTransferOrder/get', // 上缴记录详情
    list: '/merchant/app/fundTransferOrder/list', // 上缴记录列表
    count: '/merchant/app/fundTransferOrder/count', // 上缴记录总数
    update: '/merchant/app/fundTransferOrder/update', // 上缴记录修改
    cancel: '/merchant/app/fundTransferOrder/cancel', // 上缴记录撤销
    dealWithProcessOrder: '/merchant/app/fundTransferOrder/dealWithProcessOrder', // 查询订单
  },
  attendanceApply: {
    // 打卡异常
    list: "/merchant/app/attendanceApply/list", // 列表
    count: "/merchant/app/attendanceApply/count", // 列表
    apply: "/merchant/app/attendanceApply/apply", // 添加
    audit: "/merchant/app/attendanceApply/audit", // 审批
    get: "/merchant/app/attendanceApply/get", // 详情
    getAttendanceType: "/merchant/app/attendanceSet/getAttendanceType", // 获取考勤打卡类型
  },
  shopServe: {
    // 门店服务
    getSmsLeftNum: '/merchant/app/platformOrder/getSmsLeftNum', // 获取短信剩余数量
    getShopPackageExpireDay: '/merchant/app/platformOrder/getShopPackageExpireDay', // 获取门店服务到期时间
    listShopPackage: '/merchant/app/platformOrder/listShopPackage', // 获取门店服务包 列表
    listSmsPackage: '/merchant/app/platformOrder/listSmsPackage', // 获取短信服务包 列表
    createSmsPackage: '/merchant/app/platformOrder/createSmsPackage', // 短信服务 保存
    createShopPackage: '/merchant/app/platformOrder/createShopPackage', // 门店服务 保存
    get: '/merchant/app/cashCouponCard/get', // 查询优惠券
    pollingGet: '/merchant/app/platformOrder/getPayStatus', // 轮询查询订单
    listOrder: '/merchant/app/platformOrder/listOrder', // 缴费记录
    count: '/merchant/app/platformOrder/count', // 缴费记录
    cancelShopPackageOrder: 'merchant/app/platformOrder/cancelShopPackageOrder', // 旧-缴费-取消订单
    recordsGet: '/merchant/app/platformOrder/get', //  缴费记录-详情

    lklCreateSmsPackage: '/merchant/app/v2/platformOrder/createSmsPackage', // 拉卡拉短信服务
    lklCreateShopPackage: '/merchant/app/v2/platformOrder/createShopPackage', // 拉卡拉门店服务
    lklCancelShopPackageOrder: '/merchant/app/v2/platformOrder/cancelOrder', //  旧-缴费-取消订单
    lklPollingGet: '/merchant/app/v2/platformOrder/getPayStatus', // 轮询查询订单
    lklQueryOrder: '/merchant/app/v2/platformOrder/queryOrder', // 查单

    cancelOrder: 'merchant/app/V3/platformOrder/cancelOrder', // 取消订单 - 合并
    purchaseInfo: 'merchant/app/platformOrder/purchaseInfo',  // 查询门店是否首购
    listPackage: 'merchant/app/platformOrder/listPackage', // 服务套餐
    createAllPackage: 'merchant/app/V3/platformOrder/create', // 创建订单 支付微信和拉卡拉
  },
  smsStatisticsDay: { // 短信服务
    get: 'merchant/app/report/smsStatisticsDay/get', // 短信统计
    getSmsLeftNum: 'merchant/app/platformOrder/getSmsLeftNum', // 获取短信余量
    smsStatisticsList: 'merchant/app/report/smsStatisticsDay/list', // 每日明细  列表
    smsStatisticsSummary: 'merchant/app/report/smsStatisticsDay/summary', // 每日明细 汇总
    listSmsDetail: 'merchant/app/message/listSmsDetail', // 短信明细
    countSmsDetail: 'merchant/app/message/countSmsDetail', // 短信明细
    smsSendDetail: 'merchant/app/message/get', // 短信发送详情
  },
  staffSalary: { // 工资条
    list: "/merchant/app/report/staffSalary/list", // 列表
    getSalarySummary: "/merchant/app/report/staffSalary/getSalarySummary", //
    get: "/merchant/app/report/staffSalary/get", //
    shopList: "merchant/app/backupStaffShopMonth/listStaffShopByMonth", // 获取当前店员 所有的门店 根据月份
    getAppealInfo: "merchant/app/salary/getAppealInfo", // 工资申诉，获取截止时间和迟到，早退次数
    getAppealAttendanceInfo: "merchant/app/report/staffSalary/getAppealAttendanceInfo", // 工资申诉，获取考勤统计
    grant: "merchant/app/salary/grant", // 是否发放工资
  },
  staffKpiSalary: {
	shopList:"merchant/app/report/staffKpiSalary/shopList",
    get: "merchant/app/report/staffKpiSalary/get", // 短信详情
    getAppealInfo: 'merchant/app/staffKpiSalary/getAppealInfo', // 工资申诉
  },
  subsidyApply: { // 店员工资
    list: "/merchant/app/subsidyInfo/list", // 列表
    count: "/merchant/app/subsidyInfo/count", // 列表
    save: "/merchant/app/subsidyInfo/save", // 保存
    get: "/merchant/app/subsidyInfo/get", // 详情
    getAllSubsidyType: "/merchant/app/subsidyInfo/getAllSubsidyType", // 
    cancel: "merchant/app/subsidyInfo/cancel", // 撤销
    audit: "merchant/app/subsidyInfo/audit", // 审核
    staffSubsidyRightList: "merchant/app/subsidyInfo/staffSubsidyRightList", // 店员权益列表
    staffSubsidyRightCount: "merchant/app/subsidyInfo/staffSubsidyRightCount", // 店员权益列表
    staffSubsidyRightDetail: "merchant/app/subsidyInfo/staffSubsidyRightDetail", // 店员权益详情

    staffShopList: 'merchant/app/subsidyInfo/staffShopList', // 查询报销门店
    
  },
  coupon: {
    list: "/merchant/app/couponSendRecord/listByMemberId", // 卡券列表
  },
  shopWork: { // 修改厨师补贴明细
    update: "merchant/app/shopWork/update", // 修改
    details: "merchant/app/shopWork/details", // 详情
    batchUpdate: "merchant/app/shopWork/update", // 批量修改补贴明细
  },
  shopWorkConfig: { // 门店工作类型配置
    save: "merchant/app/shopWorkConfig/save", // 保存
    get: "merchant/app/shopWorkConfig/get", // 详情
  },
  staffPositionElevate: { // 店员晋升
    apply: "merchant/app/staffPositionElevate/apply", // 记录
    list: "merchant/app/staffPositionElevate/list", // 列表
    count: "merchant/app/staffPositionElevate/count", // 列表
    get: "merchant/app/staffPositionElevate/get", // 详情
    companyShopList: 'merchant/app/shop/companyShopList', // 获取公司列表
    cancel: 'merchant/app/staffPositionElevate/cancel', // 获取公司列表
  },
  smsTemplate: { // 客情维护
    memberList: "merchant/app/member/listByShopId", // 会员列表
    countByShopId:'merchant/app/member/countByShopId',// 会员总数
    smsTemplateList: "merchant/app/messageTemplate/list", //短信模版列表
    smsTemplateDetail: "merchant/app/messageTemplate/getDetail", //短信模版详情
    sendBatchSms: "merchant/app/message/sendBatchSms", //批量发送短信
    messageList: "merchant/app/message/list", // 短信发送列表
    messageCount: "merchant/app/message/count", // 短信发送列表
    get: "merchant/app/message/get", // 短信详情
    listRepairItem: 'merchant/app/v2/repairDocument/listRepairItem', // 筛选条件数据
    messageReSendBatchSms: 'merchant/app/message/reSendBatchSms', // 重新发送失败短信
  },
  purchaseStorageInfo: {  // 新增采购
    supplierInfoList: 'wms/app/supplierInfo/list', // 获取所有供应商信息
    save: 'wms/app/inventoryBillInfo/purchaseStorage', //保存
    getShopFirstHandStorageCase: 'wms/app/inventoryShopConfig/getShopFirstHandStorageCase', //获取门店首次手动入库情况
  },
  consumableInfo: {
    // 其他 选择产品
    consumableList: '/wms/app/consumableInfo/consumableList', // 获取所有耗材
    productList: '/wms/app/consumableInfo/productList', // 获取所有产品列表
  },
  inventoryStorageInfo: {  // 产品入库
    pullDownList: '/wms/app/inventoryBillCategory/pullDownList', //入库原因
    save: '/wms/app/inventoryBillInfo/handStorage', //保存
  },
  inventoryWastageInfo: {  // 产品出库
    list: '/wms/app/inventoryBillInfo/wastageList', //出库列表
    count: '/wms/app/inventoryBillInfo/wastageCount', //
    pullDownList: '/wms/app/inventoryBillCategory/pullDownList', //出库原因
    save: '/wms/app/inventoryBillInfo/handWastage', //保存
    get: '/wms/app/inventoryBillInfo/get', //详情
    recall: '/wms/app/inventoryBillInfo/recall', //撤销
  },
  checkBillInfo: { //库存盘点
    // 盘点
    list: '/wms/app/checkBillInfo/list', // 列表
    count: '/wms/app/checkBillInfo/count', // count
    save: '/wms/app/checkBillInfo/save', // 保存
    delete: '/wms/app/checkBillInfo/delete', // 删除
    cancel: '/wms/app/checkBillInfo/cancel', // 作废
    recall: '/wms/app/checkBillInfo/recall', // 撤销
    submit: '/wms/app/checkBillInfo/submit', // 提交盘点
    get: '/wms/app/checkBillInfo/get', // 详情
  },
  inventoryProduct: {
    // 库存查询
    getShopForProduct: "wms/app/inventoryProduct/getShopForProduct",
    listForCategory: '/wms/app/inventoryProduct/listForCategory', // 根据状态  获取产品分类
    // 盘点 选择产品
    consumableListByShopId: '/wms/app/inventoryProduct/consumableListByShopId', // 获取所有耗材
    productListByShopId: '/wms/app/inventoryProduct/productListByShopId', // 获取所有产品列表
  },
  checkBillItem: {
    save: '/wms/app/checkBillItem/save', // 单个确定盘点
  },
  inventoryBillInfo: {
    // 出入库记录
    list: 'wms/app/inventoryBillInfo/list', // 列表
    count: '/wms/app/inventoryBillInfo/count', //
    get: 'wms/app/inventoryBillInfo/get', // 详情
  },
  shopBill: { // 收支账明细
    get: 'merchant/app/report/shopBill/get'
  },
  shopStaffFee: { // 收支账 应发明细
    get: 'merchant/app/shopStaffFee/get'
  },
  inventoryProduct: {
    // 库存查询
    getShopForProduct: "wms/app/inventoryProduct/getShopForProduct",
    // 盘点 选择产品
    consumableListByShopId: '/wms/app/inventoryProduct/consumableListByShopId', // 获取所有耗材
    productListByShopId: '/wms/app/inventoryProduct/productListByShopId', // 获取所有产品列表
    listForCategory: '/wms/app/inventoryProduct/listForCategory', // 根据状态  获取产品分类
  },
  inventoryDay: {
    get: 'wms/app/report/inventoryDay/get', // 日列表
  },
  inventoryShopConfig: {
    // 门店预警开关
    getShopWarningConfig: 'wms/app/inventoryShopConfig/getShopWarningConfig', // 获取门店预警开关配置
    switchShopWarningConfig: 'wms/app/inventoryShopConfig/switchShopWarningConfig', // 开关门店预警设置
    list: 'wms/app/inventoryProduct/list', // 列表
    update: 'wms/app/inventoryProduct/update', // 修改
  },
  consumableCategory: {
    // 耗材分类
    list: 'wms/app/consumableCategory/list', // 列表
  },

  //版本更新
  versionManage: {
    //订单作废
    list: '/merchant/app/versionManage/list', //作废列表
    count: '/merchant/app/versionManage/count', //作废总数
    get: '/merchant/app/versionManage/get', //作废详情
  },

  // 权限
  auth: {
    list: '/merchant/app/companyRole/list', // 权限列表
    getDetails: '/merchant/app/companyRole/get', // 权限详情
    appList:'/merchant/app/companyStaffRole/listStaffInfo', // 可应用账号列表
    listUseStaffInfo:'/merchant/app/companyStaffRole/listUseStaffInfo', // 当前角色应用账号列表
    edtiList:'/merchant/app/menu/listShopMenu', // 权限编辑列表
    saveAuth:'/merchant/app/companyRole/save', // 权限保存
    appSave:'/merchant/app/companyStaffRole/save', // 权限应用保存
    listOptionalRole:'/merchant/app/companyRole/listOptionalRole'
  },
  pingan: {
    getBankNoList: '/merchant/app/bankInfo/getBankNoList', // 获取联行号
  },
  shopBillImportFee: {
    get: '/merchant/app/shopBillImportFee/get'
  },
  memberDataDay: {
    listOfRecharge: '/merchant/app/report/memberDataDay/listOfRecharge', // 获取会员充值排行
    countOfRecharge: '/merchant/app/report/memberDataDay/countOfRecharge', // 
    listOfConsume: '/merchant/app/report/memberDataDay/listOfConsume', // 获取会员消费排行
    countOfConsume: '/merchant/app/report/memberDataDay/countOfConsume', // 
    listOfConsumeTotal: '/merchant/app/report/memberDataDay/listOfConsumeTotal', // 获取会员消费频次排行
    countOfConsumeTotal: '/merchant/app/report/memberDataDay/countOfConsumeTotal', // 
  },
  memberMessageRecord: {
    list: '/merchant/app/memberMessageRecord/list',
    count: '/merchant/app/memberMessageRecord/count',
  }
  
}
